import { Injectable } from '@angular/core';
import { Route } from '@angular/router';
import { Page } from 'src/app/models/data/page.model';
import { AuthGuard } from 'src/app/guards/auth/auth.guard';
import { StatGuard } from 'src/app/guards/stat/stat.guard';
import { ChildGuard } from 'src/app/guards/child/child.guard';
import { StatQuestionDetailComponent } from 'src/app/components/content/survey/stat-questions/stat-question-detail/stat-question-detail.component';
import { ImpactQuestionsDetailComponent } from 'src/app/components/content/survey/impact/impact-questions-detail/impact-questions-detail.component';

@Injectable({
  providedIn: 'root'
})
export class RouteGeneratorService {

  generateRoutesFromPages(pages: Page[], existingStaticRoutes: Route[] = []): Route[] {
    console.log('🛣️ ROUTE GENERATOR DEBUG: Starting route generation');
    console.log('🛣️ ROUTE GENERATOR DEBUG: Input pages:', pages);
    console.log('🛣️ ROUTE GENERATOR DEBUG: Existing static routes:', existingStaticRoutes);

    const dynamicRoutes: Route[] = [];

    // Filter to only Type 1 (survey) or Type 2 (impact) pages
    // BUT exclude routes that already have static routes with custom components
    // Also explicitly exclude special pages that use custom components
    const excludedRoutes = ['current-ethnic-groups', 'future-ethnic-groups', 'photo-upload', 'submit-survey'];

    const surveyAndImpactPages = pages.filter(p => {
      const route = p.Route.startsWith('/') ? p.Route.substring(1) : p.Route;

      // Don't create dynamic route if it's in the exclusion list
      if (excludedRoutes.includes(route)) {
        console.log('🛣️ ROUTE GENERATOR DEBUG: Skipping', route, '- excluded route with custom component');
        return false;
      }

      // Don't create dynamic route if static route already exists for this path
      const staticRouteExists = existingStaticRoutes.some(r => r.path === route);

      if (staticRouteExists) {
        console.log('🛣️ ROUTE GENERATOR DEBUG: Skipping', route, '- static route already exists');
      }

      return (p.Type === 1 || p.Type === 2) && !staticRouteExists;
    });
    console.log('🛣️ ROUTE GENERATOR DEBUG: Filtered pages (Type 1 & 2, no static conflicts):', surveyAndImpactPages);

    surveyAndImpactPages.forEach(page => {
      const route = page.Route.startsWith('/') ? page.Route.substring(1) : page.Route;
      console.log('🛣️ ROUTE GENERATOR DEBUG: Processing page:', page.Title, 'Route:', route, 'Type:', page.Type);

      if (page.Type === 1) {
        // Survey pages (Type 1)
        console.log('🛣️ ROUTE GENERATOR DEBUG: Adding survey route:', route);
        const routeConfig = {
          path: route,
          canActivate: [AuthGuard, StatGuard],
          component: StatQuestionDetailComponent
        };
        console.log('🛣️ ROUTE GENERATOR DEBUG: Route config for', route, ':', routeConfig);
        dynamicRoutes.push(routeConfig);
      } else if (page.Type === 2) {
        // Impact pages (Type 2)
        console.log('🛣️ ROUTE GENERATOR DEBUG: Adding impact route:', route);
        dynamicRoutes.push({
          path: route,
          canActivate: [AuthGuard, ChildGuard],
          component: ImpactQuestionsDetailComponent
        });
      }
    });

    console.log('🛣️ ROUTE GENERATOR DEBUG: Generated dynamic routes:', dynamicRoutes);
    return dynamicRoutes;
  }
}
